import React from "react";

/**
 * Persistent ownership badge fixed bottom-left.
 * Shown on every authenticated page.
 */
export function OwnedByBadge() {
  return (
    <div
      className="fixed left-1/2 -translate-x-1/2 z-50 inline-flex items-center gap-2 rounded-full border bg-background/90 backdrop-blur px-3 py-1.5 text-[11px] text-muted-foreground shadow-[0_4px_14px_rgba(15,23,42,0.10)] pointer-events-auto whitespace-nowrap"
      style={{ bottom: "calc(env(safe-area-inset-bottom) + 16px)" }}
      data-testid="owned-badge"
    >
      <span className="h-1.5 w-1.5 rounded-full bg-primary" />
      Owned by <span className="font-medium text-foreground">ITCOT Limited</span>
    </div>
  );
}
